module.exports = __webpack_public_path__ + "media/img/pages/companies/buhler-1b4e7833323e89136fa5d41ccb4fe5f4.png";